import { Component } from '@angular/core';
import { SidebarService } from '../../../services';

@Component({
  selector: 'app-hamburger-menu',
  templateUrl: './hamburger-menu.component.html',
  styleUrls: ['./hamburger-menu.component.css'],
  standalone: true,
  imports: []
})
export class HamburgerMenuComponent {

  constructor(
    private readonly _sidebarService: SidebarService
  ) { }

  toggleSidebar() {
    this._sidebarService.toggle();
  }
}
